module.exports = __webpack_public_path__ + "bbcbd48998d484797b9ea290f22041a6.png";